import React, { useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
} from "react-native";

const DynamicWidthScreen = () => {
  const [columnsWidth, setColumnsWidth] = useState([100, 150, 200, 120, 150]);
  const [rowsHeight, setRowsHeight] = useState([50, 50, 50]);

  // Sample data for the table
  const data = [
    {
      id: 1,
      orderNumber: "3270507",
      itemCode: "AB130442",
      itemName: "M-150C2 Driscolls Blueberry",
      customerName: "Costa Exchange PTY LTD",
    },
    {
      id: 2,
      orderNumber: "3270508",
      itemCode: "MA102232",
      itemName: "T-255 Base",
      customerName: "Ray NG",
    },
    {
      id: 3,
      orderNumber: "3270509",
      itemCode: "AB130442",
      itemName: "M-150C2 Driscolls Blueberry",
      customerName: "Costa Exchange PTY LTD",
    },
    {
      id: 4,
      orderNumber: "3270510",
      itemCode: "AB130442",
      itemName: "M-150C2 Driscolls Blueberry",
      customerName: "Costa Exchange PTY LTD",
    },
  ];

  const handleColumnResize = (
    index: number,
    direction: "increase" | "decrease"
  ) => {
    const newWidth = [...columnsWidth];
    if (direction === "increase") {
      newWidth[index] = Math.min(newWidth[index] + 20, 300); // Limit max width
    } else if (direction === "decrease" && newWidth[index] > 80) {
      // Limit min width
      newWidth[index] = newWidth[index] - 20;
    }
    setColumnsWidth(newWidth);
  };

  const handleRowResize = (
    index: number,
    direction: "increase" | "decrease"
  ) => {
    const newHeight = [...rowsHeight];
    if (direction === "increase") {
      newHeight[index] = Math.min(newHeight[index] + 10, 100); // Limit max height
    } else if (direction === "decrease" && newHeight[index] > 30) {
      // Limit min height
      newHeight[index] = newHeight[index] - 10;
    }
    setRowsHeight(newHeight);
  };

  // Function to resize all columns at once
  const handleResizeAllColumns = (direction: "increase" | "decrease") => {
    const newWidth = columnsWidth.map((width) => {
      if (direction === "increase") {
        return Math.min(width + 20, 300); // Limit max width
      } else if (direction === "decrease" && width > 80) {
        return width - 20; // Limit min width
      }
      return width;
    });
    setColumnsWidth(newWidth);
  };

  // Function to resize all rows at once
  const handleResizeAllRows = (direction: "increase" | "decrease") => {
    const newHeight = rowsHeight.map((height) => {
      if (direction === "increase") {
        return Math.min(height + 10, 80); // Limit max height
      } else if (direction === "decrease" && height > 30) {
        return height - 10; // Limit min height
      }
      return height;
    });
    setRowsHeight(newHeight);
  };

  return (
    <View style={styles.container}>
      <ScrollView horizontal style={styles.tableWrapper}>
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={[styles.tableHeaderCell, { width: columnsWidth[0] }]}>
              ID
            </Text>
            <Text style={[styles.tableHeaderCell, { width: columnsWidth[1] }]}>
              Name
            </Text>
            <Text style={[styles.tableHeaderCell, { width: columnsWidth[2] }]}>
              Age
            </Text>
            <Text style={[styles.tableHeaderCell, { width: columnsWidth[3] }]}>
              City
            </Text>
            <Text style={[styles.tableHeaderCell, { width: columnsWidth[4] }]}>
              Salary
            </Text>
          </View>
          {data.map((row, rowIndex) => (
            <View
              key={row.id}
              style={[styles.tableRow, { height: rowsHeight[rowIndex] }]}
            >
              <Text style={[styles.tableCell, { width: columnsWidth[0] }]}>
                {row.id}
              </Text>
              <Text style={[styles.tableCell, { width: columnsWidth[1] }]}>
                {row.orderNumber}
              </Text>
              <Text style={[styles.tableCell, { width: columnsWidth[2] }]}>
                {row.itemCode}
              </Text>
              <Text style={[styles.tableCell, { width: columnsWidth[3] }]}>
                {row.itemName}
              </Text>
              <Text style={[styles.tableCell, { width: columnsWidth[4] }]}>
                {row.customerName}
              </Text>
            </View>
          ))}
        </View>
      </ScrollView>

      {/* Sticky Bar */}
      <View style={styles.stickyBar}>
        <Text style={styles.stickyBarText}>Resize Columns</Text>
        {columnsWidth.map((width, index) => (
          <View key={index} style={styles.resizeButtons}>
            <TouchableOpacity
              onPress={() => handleColumnResize(index, "increase")}
              style={styles.resizeButton}
            >
              <Text style={styles.button}>+</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => handleColumnResize(index, "decrease")}
              style={styles.resizeButton}
            >
              <Text style={styles.button}>-</Text>
            </TouchableOpacity>
          </View>
        ))}

        {/* Resize All Columns */}
        <Text style={styles.stickyBarText}>Resize All Columns</Text>
        <View style={styles.resizeButtons}>
          <TouchableOpacity
            onPress={() => handleResizeAllColumns("increase")}
            style={styles.resizeButton}
          >
            <Text style={styles.button}>Increase All</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => handleResizeAllColumns("decrease")}
            style={styles.resizeButton}
          >
            <Text style={styles.button}>Decrease All</Text>
          </TouchableOpacity>
        </View>

        <Text style={styles.stickyBarText}>Resize Rows</Text>
        {rowsHeight.map((height, index) => (
          <View key={index} style={styles.resizeButtons}>
            <TouchableOpacity
              onPress={() => handleRowResize(index, "increase")}
              style={styles.resizeButton}
            >
              <Text style={styles.button}>+</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => handleRowResize(index, "decrease")}
              style={styles.resizeButton}
            >
              <Text style={styles.button}>-</Text>
            </TouchableOpacity>
          </View>
        ))}

        {/* Resize All Rows */}
        <Text style={styles.stickyBarText}>Resize All Rows</Text>
        <View style={styles.resizeButtons}>
          <TouchableOpacity
            onPress={() => handleResizeAllRows("increase")}
            style={styles.resizeButton}
          >
            <Text style={styles.button}>Increase All</Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => handleResizeAllRows("decrease")}
            style={styles.resizeButton}
          >
            <Text style={styles.button}>Decrease All</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
    padding: 10,
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  tableWrapper: {
    flex: 1,
  },
  table: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 10,
    overflow: "hidden",
    marginRight: 180, // Make room for the sticky bar
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5",
    borderBottomWidth: 2,
    borderColor: "#ccc",
  },
  tableHeaderCell: {
    padding: 12,
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 16,
    color: "#333",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#ccc",
  },
  tableCell: {
    padding: 15,
    textAlign: "center",
    fontSize: 14,
    color: "#333",
  },
  stickyBar: {
    position: "absolute",
    top: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: 20,
    borderWidth: 1,
    borderColor: "#ccc",
    height: "100%",
    justifyContent: "flex-start",
    alignItems: "center",
    zIndex: 10,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
  },
  stickyBarText: {
    fontWeight: "bold",
    marginBottom: 15,
    fontSize: 18,
    color: "#333",
  },
  resizeButtons: {
    flexDirection: "row",
    justifyContent: "center",
    marginBottom: 15,
  },
  resizeButton: {
    padding: 8,
    borderRadius: 8,
    backgroundColor: "#e0e0e0",
    margin: 5,
  },
  button: {
    fontSize: 14,
    color: "#333",
  },
});

export default DynamicWidthScreen;
